<!-- page title -->
<div class="page-title" *ngIf="false">
    <h2> Analytics Dashboard</h2>
</div>

<div>
    <br>
    <mat-card>
        <br>

        <form #search="ngForm" (ngSubmit)="searchForm(search)">
            <div fxFlex fxLayoutGap="30px">

                <!--user type-->
                <div fxFlex="100" fxFlex.sm="50" fxFlex.gt-md="25">
                    <mat-form-field class="example-full-width" appearance="outline">
                        <mat-label>Record Categories</mat-label>
                        <mat-select (selectionChange)="onUserTypeChange($event.value)">
                            <mat-option value="gc">General Contractor</mat-option>
                            <mat-option value="lc">Sub Contractor</mat-option>
                            <mat-option value="project">Project</mat-option>
                            <mat-option value="supply">Supply</mat-option>
                            <mat-option value="requisition">Requisition</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <!--user name-->

                <!-- gc  -->
                <div fxFlex="100" fxFlex.sm="50" fxFlex.gt-md="25" *ngIf="gcShow">
                    <mat-label style="position: relative;
                    bottom: 15px;">Users List </mat-label>
                    <ng-select placeholder="List Of GC Users" [ngModel]="default_val" name="company_name" required
                        [items]="userList" bindValue="company_name" bindLabel="company_name"
                        [multiple]="false"></ng-select>
                </div>
                <!-- lc  -->
                <div fxFlex="100" fxFlex.sm="50" fxFlex.gt-md="25" *ngIf="lcShow">
                    <mat-label style="position: relative;
                    bottom: 15px;"> Users List </mat-label>
                    <ng-select placeholder="List Of LC Users" ngModel name="company_name" required [items]="userList"
                        bindValue="company_name" bindLabel="company_name" [multiple]="false"></ng-select>
                </div>
                <!-- project  -->
                <div fxFlex="100" fxFlex.sm="50" fxFlex.gt-md="25" *ngIf="projectShow">
                    <mat-label style="position: relative;
                    bottom: 15px;"> Project List </mat-label>
                    <ng-select placeholder="List Of Projects" ngModel name="project_name" required [items]="userList"
                        bindValue="project_name" bindLabel="project_name" [multiple]="false"></ng-select>
                </div>
                <!-- supply  -->
                <div fxFlex="100" fxFlex.sm="50" fxFlex.gt-md="25" *ngIf="supplyShow">
                    <mat-label style="position: relative;
                    bottom: 15px;"> Supply List </mat-label>
                    <ng-select placeholder="List Of Supply" ngModel name="company_name" required [items]="userList"
                        bindValue="company_name" bindLabel="company_name" [multiple]="false"></ng-select>
                </div>
                <!-- requisition  -->
                <div fxFlex="100" fxFlex.sm="50" fxFlex.gt-md="25" *ngIf="requisitionShow">
                    <mat-label style="position: relative;
                    bottom: 15px;"> Requisition List </mat-label>
                    <ng-select placeholder="List Of Requisition" ngModel name="company_name" required [items]="userList"
                        bindValue="company_name" bindLabel="company_name" [multiple]="false"></ng-select>
                </div>


                <!-- date picker start/end date -->
                <div fxFlex="100" fxFlex.sm="50" fxFlex.gt-md="25">
                    <mat-form-field class="example-form-field" appearance="outline">
                        <mat-label>Start Date - End Date</mat-label>
                        <mat-date-range-input [rangePicker]="startDatePicker" [comparisonStart]="endDate.value.start"
                            [comparisonEnd]="endDate.value.end">
                            <input matStartDate placeholder="Start date" datePickerFormat="YYYY/MM/DD" ngModel
                                name="from_date">
                            <input matEndDate placeholder="End date" datePickerFormat="YYYY/MM/DD" ngModel
                                name="to_date">
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                        <mat-date-range-picker #startDatePicker></mat-date-range-picker>
                    </mat-form-field>
                </div>

                <!-- button serch -->
                <div class="search-button-wrapper" fxLayout="row" fxLayoutGap="20px">
                    <button type="submit" mat-mini-fab>
                        <mat-icon aria-hidden="false" aria-label="Example home icon">search</mat-icon>
                    </button>

                    <button (click)="resetval()" mat-mini-fab><mat-icon aria-hidden="false"
                            aria-label="Example home icon">search_off</mat-icon></button>
                </div>


                <!-- download section -->
                <button mat-mini-fab type="button" matTooltip="Download" id="dropdownMenuButton" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
                    <mat-icon aria-hidden="false" aria-label="Example home icon">menu</mat-icon>
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <a class="dropdown-item link" (click)="exportexcel('excel-table-total-records')">Download EXCEL
                        document</a>
                    <a class="dropdown-item link" (click)="printPage()">Download PDF document</a>
                    <a class="dropdown-item link" (click)="printPage2()">Print Page</a>
                </div>
                <!-- download section -->
            </div>
        </form>

        <!-- <button type="submit" mat-mini-fab>
            <mat-icon aria-hidden="false" aria-label="Example home icon" type="button" (click)="exportAsXLSX()">download</mat-icon>
        </button> -->

        <!-- <button type="button" class="btn btn-danger" (click)="getExceldata()">hie</button> -->
    </mat-card>

</div><br><br>
<!--dashboard count  widgets-->
<div *ngIf="onSearch" class="count" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px"
    class="stats-cards">
    <mat-card class="count bg-1" fxFlex="100" fxFlex.sm="50" fxFlex.gt-md="25">
        <app-widget-card class="count" label="Registered General Contractor/Developers"
            total="{{general_contractor_count}}" percentage="50" [data]="cards"></app-widget-card>
    </mat-card>
    <mat-card class="count bg-2" fxFlex="100" fxFlex.sm="50" fxFlex.gt-md="25">
        <app-widget-card cl label="Registered Projects" total="{{project_count}}" percentage="40" [data]="cards">
        </app-widget-card>
    </mat-card>
    <mat-card class="count bg-3" fxFlex="100" fxFlex.sm="50" fxFlex.gt-md="25">
        <app-widget-card label="Registered Sub Contractors" total="{{sub_contractor_count}}" percentage="50"
            [data]="cards"></app-widget-card>
    </mat-card>
    <mat-card class="count bg-4" fxFlex="100" fxFlex.sm="50" fxFlex.gt-md="25">
        <app-widget-card label="Total Requisitions" total="{{requisition_count}}" percentage="30" [data]="cards">
        </app-widget-card>
    </mat-card>
</div><br>

<br>


<div *ngIf="onSearch" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px" class="stats-cards">

    <mat-card class="count bg-5" fxFlex="100" fxFlex.sm="50" fxFlex.gt-md="25">
        <app-widget-card label="Total Supply" total="{{supply_count}}" percentage="40" [data]="cards"></app-widget-card>
    </mat-card>
    <mat-card class="count bg-3" fxFlex="100" fxFlex.sm="50" fxFlex.gt-md="25">
        <app-widget-card label="Total Labor Available" total="{{supply_labour_count}}" percentage="30" [data]="cards">
        </app-widget-card>
    </mat-card>
    <mat-card class="count bg-2" fxFlex="100" fxFlex.sm="50" fxFlex.gt-md="25">
        <app-widget-card label="Total Labor Requireds" total="{{requisition_labour_count}}" percentage="20"
            [data]="cards"></app-widget-card>
    </mat-card>
    <mat-card class="count bg-1" fxFlex="100" fxFlex.sm="50" fxFlex.gt-md="25">
        <app-widget-card label="Total Users" total="{{user_count}}" percentage="30" [data]="cards"></app-widget-card>
    </mat-card>
</div>

<br>


<div id="table">

    <!--  big chart -->
    <div style="margin: 20px;">
        <h2 class="title_types" *ngIf="companyName">{{userTypeValue}} - {{title.company_name}} <span
                *ngIf="title.from_date" style="color: black;"> Report - From {{title.from_date | date:'dd-MM-yyyy'}} To
                {{title.to_date | date:'dd-MM-yyyy'}}</span></h2>
        <highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions" class="Charts"></highcharts-chart>
    </div>


    <!-- on page overall gc and lc interaction  -->
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px" *ngIf="onSearch" style="margin: 20px;">
        <div fxFlex="50">
            <highcharts-chart [Highcharts]="Highcharts" [options]="gcUserOptions" class="Charts"></highcharts-chart>
        </div>
        <div fxFlex="50">
            <highcharts-chart class="Charts" [Highcharts]="Highcharts" [options]="lcUserOptions"></highcharts-chart>
        </div>
    </div>

    <!-- Dashboard activity track -->
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px" *ngIf="onSearch"
        style="margin: 20px; background-color: white">
        <div fxFlex="50">
            <h6 class="chart-of-dashboard ">LC Dashboard Activity</h6>
            <canvas id="myChart1" width="700" height="250" #mychart1></canvas>
            <br><br>
        </div>
        <div fxFlex="50">
            <h6 class="chart-of-dashboard ">GC Dashboard Activity </h6>
            <canvas id="myChart" width="700" height="250" #mychart></canvas>
            <br><br>
        </div>

    </div>



    <!-- pie chart -->
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px" *ngIf="onSearch" style="margin: 20px;">
        <div fxFlex="50" *ngIf="onSearch">
            <highcharts-chart class="Charts" [Highcharts]="Highcharts" [options]="UserTypesOptions"></highcharts-chart>

        </div>
        <div fxFlex="50" *ngIf="onSearch" style="margin: 20px; background-color: white; height: 400px;">

            <div class="container" style="height: 250px;">
                <div class="row">

                    <h6 style="text-align:center; font-weight: 900;
                    margin-top: 12px;"> &nbsp;&nbsp;&nbsp;&nbsp; Total General Contractor and Sub Contractor Counts
                    </h6><br>
                    <div class="col-6 mt-4">
                        <div class="jumbotron style-01">
                            <span class="display-5">
                                General Contractor <br>
                                <h1> {{UserTypesOptions['series'][0]['data'][0]['y']}}</h1>
                            </span>
                        </div>
                    </div>

                    <!-- box shadow style -02 -->
                    <div class="col-6 mt-4">
                        <div class="jumbotron style-02">
                            <span class="display-5">
                                Sub Contractor <br>
                                <h1> {{UserTypesOptions['series'][0]['data'][1]['y']}}</h1>
                            </span>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
    <br>


    <!-- user engaged and non-engaged analytics and gc and lc enagegedment -->
    <div fxLayout="row" fxLayoutAlign="space-between center" *ngIf="onSearch" fxLayoutGap="20px" style="margin: 20px;">

        <div fxFlex="50">
            <highcharts-chart [Highcharts]="Highcharts" [options]="getGcLcUserPierCharts"
                class="Charts"></highcharts-chart>
        </div>
        <div fxFlex="50">
            <highcharts-chart [Highcharts]="Highcharts" [options]="getUserPierCharts" class="Charts"></highcharts-chart>
        </div>

    </div>



    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px" style="margin: 20px;">
        <div fxFlex="100">
            <highcharts-chart [Highcharts]="Highcharts" [options]="PieChartOption" class="Charts"></highcharts-chart>
        </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px"
        style="margin: 20px; background-color: white;">
        <div fxFlex="50">
            <h6 class="chart-of-dashboard ">Calling Activity </h6>
            <canvas id="callingActivity" width="700" height="250" #callingActivity></canvas><br><br>
        </div>
    </div>

    <br><br>

</div>

<br>

<!-- table formate data -->
<div style="display: none;">

    <!-- dashboard overall count data -->
    <!-- <table id="excel-table-total-records">
        <tr>
            <th>No.</th>
            <th>Types</th>
            <th>Count</th>
        </tr>
        <tr>
            <td>1</td>
            <td>Total General Contractor</td>
            <td>{{general_contractor_count}}</td>
        </tr>
        <tr>
            <td>2</td>
            <td>Total Sub Contractor</td>
            <td>{{sub_contractor_count}}</td>
        </tr>
        <tr>
            <td>3</td>
            <td>Total Project</td>
            <td>{{project_count}}</td>
        </tr>
        <tr>
            <td>4</td>
            <td>Total Requisitionr</td>
            <td>{{requisition_count}}</td>
        </tr>
        <tr>
            <td>5</td>
            <td>Total Requisition Labor Count</td>
            <td>{{requisition_labour_count}}</td>
        </tr>
        <tr>
            <td>6</td>
            <td>Total Supply</td>
            <td>{{supply_count}}</td>
        </tr>
        <tr>
            <td>7</td>
            <td>Total Supply Labor Count</td>
            <td>{{supply_labour_count}}</td>
        </tr>
        <tr>
            <td>8</td>
            <td>Total Register User</td>
            <td>{{user_count}}</td>
        </tr>
    </table> -->


    <!-- user anlytics records -->
    <!-- <table id="overall-user-analytics" style="display: none;">
        <tr>
            <th>No. </th>
            <th>Created Date</th>
            <th>User Type</th>
            <th>Screen Type</th>
            <th>User Name</th>
            <th>Mobile Number</th>
        </tr>
        <tr *ngFor="let item of userAnlyticsData let i=index ">
            <td>{{i+1}}</td>
            <td>{{item?.created_date}}</td>
            <td>{{item?.user_type}}</td>
            <td>{{item?.screen_name}}</td>
            <td>{{item?.name}}</td>
            <td>{{item?.mobile_no}}</td>
        </tr>
    </table> -->

    <!-- requisition search analytics information ---------api 1-->
    <!-- <table id="requisition_search_analytics">
        <tr>
            <th>No</th>
            <th>Visited Date</th>
            <th>Project Name</th>
            <th>Name</th>
            <th>Mobile No.</th>
            <th>Activity Name</th>
            <th>Sub Activity Name</th>
            <th>Labor Count</th>
            <th>User Type</th>
        </tr>
        <tr *ngFor="let data of requisitionSearchAnalytics let i=index;">
            <td>{{i+1}}</td>
            <td>{{data.visited_date}}</td>
            <td>{{data.project_name}}</td>
            <td>{{data.name}}</td>
            <td>{{data.mobile_no}}</td>
            <td>{{data.activity_name}}</td>
            <td>{{data.sub_activity_name}}</td>
            <td>{{data.labour_count}}</td>
            <td>{{data.user_type}}</td>
        </tr>
    </table> -->


    <!--  requisition search lc calling  api 2 table  -->
    <!-- <table id="requisition_search_calling_analytics">
        <tr>
            <th>No.</th>
            <th>Visited date</th>
            <th>Project name</th>
            <th>Activity name</th>
            <th>Sub Activity name</th>
            <th>Sub contractor company name</th>
            <th>User name</th>
            <th>Mobile no.</th>
            <th>User type</th>
        </tr>
        <tr *ngFor="let data of requisitionLcCalling  let i=index;">
            <th>{{i+1}}</th>
            <th>{{data.visited_date}}</th>
            <th>{{data.project_name}}</th>
            <th>{{data.activity_name}}</th>
            <th>{{data.sub_activity_name}}</th>
            <th>{{data.sub_contractor_company_name}}</th>
            <th>{{data.user_name}}</th>
            <th>{{data.mobile_no}}</th>
            <th>{{data.user_type}}</th>
        </tr>
    </table> -->

    <!-- lc profile visit data api 3 table -->
    <!-- <table id="lc_profile_visit_analytics">
        <tr>
            <th>No.</th>
            <th>Visited date</th>
            <th>Project name</th>
            <th>Activity name</th>
            <th>Sub Activity name</th>
            <th>Sub contractor company name</th>
            <th>User name</th>
            <th>Mobile no.</th>
            <th>User type</th>
        </tr>
        <tr *ngFor="let data of lcProfileVisit  let i=index;">
            <th>{{i+1}}</th>
            <th>{{data.visited_date}}</th>
            <th>{{data.project_name}}</th>
            <th>{{data.activity_name}}</th>
            <th>{{data.sub_activity_name}}</th>
            <th>{{data.sub_contractor_name}}</th>
            <th>{{data.name}}</th>
            <th>{{data.mobile_no}}</th>
            <th>{{data.user_type}}</th>
        </tr>
    </table> -->

    <!-- supply search page visit data api 5 -->
    <!-- <table id="supply_search_analytics" style="display: none;">
        <tr>
            <th>No.</th>
            <th>Visited date</th>
            <th>Activity name</th>
            <th>Sub Activity name</th>
            <th>company name</th>
            <th>Labor count</th>
            <th>User name</th>
            <th>Mobile no.</th>
            <th>User type</th>
        </tr>


        <tr *ngFor="let data of supplySearchAnalytics  let i=index;">
            <th>{{i+1}}</th>
            <th>{{data.visited_date}}</th>
            <th>{{data.activity_name}}</th>
            <th>{{data.sub_activity_name}}</th>
            <th>{{data.company_name}}</th>
            <th>{{data.labour_count}}</th>
            <th>{{data.name}}</th>
            <th>{{data.mobile_no}}</th>
            <th>{{data.user_type}}</th>
        </tr>
    </table> -->


    <!-- project profile  calling  data api 6 table -->
    <!-- <table id="project_profile_calling_analytics">
        <tr>
            <th>No.</th>
            <th>Visited date</th>
            <th>Project name</th>
            <th>Activity name</th>
            <th>Sub Activity name</th>
            <th>Sub contractor company name</th>
            <th>User name</th>
            <th>Mobile no.</th>
            <th>User type</th>
        </tr>
        <tr *ngFor="let data of projectProfileCalling  let i=index;">
            <th>{{i+1}}</th>
            <th>{{data.visited_date}}</th>
            <th>{{data.project_name}}</th>
            <th>{{data.activity_name}}</th>
            <th>{{data.sub_activity_name}}</th>
            <th>{{data.sub_contractor_name}}</th>
            <th>{{data.name}}</th>
            <th>{{data.mobile_no}}</th>
            <th>{{data.user_type}}</th>
        </tr>
    </table> -->



</div>



<br>
<br>
<br>